import { createStore, applyMiddleware, compose } from 'redux';

// Load middlewares
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage

// rootReducer
import rootReducer from './rootReducer';

// Persist configuration
const persistConfig = {
  key: 'likiee-root',
  storage,
  whitelist: ['projects', 'products', 'home', 'account', 'projectItems', 'projectImages', 'follows'], // What to persist
  blacklist: [], // Don't persist these (auth handled by AWS Amplify)
  throttle: 1000, // Save at most once per second
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const initialState = {};
const middleware = [thunk];
const enhancers = [];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

export const store = createStore(
  persistedReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    ...enhancers,
  ),
);

export const persistor = persistStore(store);

export default store;
